// /guide/service-guide/faq/ で使用

export default () => {

  const f = {}
  const init = () => {
    console.log('init faq')
    f.root = document.getElementById('guide-faq');
    if (!f.root) {
      return
    }

    buildAccordion();
  }

  const buildAccordion = () => {
    f.accordions = f.root.querySelectorAll('.js-accordion');
    if (f.accordions.length) {
      f.accordions.forEach(accordion => {
        initAccordion(accordion);
      })
    }
  }

  const initAccordion = (accordion) => {
    const accordionTarget = accordion.querySelector('.js-accordion-target');
    const accordionBody = accordion.querySelector('.js-accordion-body');

    accordionTarget.addEventListener('click', (e) => {
      e.preventDefault();
      bindClickAccordionAction(accordion, accordionBody);
      accordionTarget.classList.toggle('is-selected');
    });
  }
  const bindClickAccordionAction = (accordion, body) => {
    const isOpen = accordion.classList.contains('is-open');
    if (isOpen) {
      accordionBodyCloseAction(body);
    } else {
      accordionBodyOpenAction(body);
    }
    accordion.classList.toggle('is-open');
  }
  const accordionBodyOpenAction = (body) => {
    const entity = body.firstElementChild;
    const entityHeight = entity.offsetHeight;
    body.style.height = `${entityHeight}px`;
  }
  const accordionBodyCloseAction = (body) => {
    body.style.height = '0px';
  }

  init();

  return {}
}
